import { Group, InfiniteTable } from '@/components/_common';
import { useSpedDocumentList } from '@/core/domain/sped/sped-documents/sped-documents.hooks';
import {
  SpedDocumentListRequest,
  SpedDocumentStatusColor,
  SpedDocumentStatusLabel,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import SpedDocumentEditAction from './SpedDocumentEditAction';
import SpedDocumentDeleteAction from './SpedDocumentDeleteAction';
import { useEffect, useState } from 'react';
import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import { useDebounce } from '@/hooks';
import usePageSearchHistory from '@/hooks/pageSearchHistory';
import SpedDocumentListFilter from './SpedDocumentListFilter';
import moment from 'moment';
import StatusTag from '@/components/_common/StatusTag';

export default function SpedDocumentList() {
  const [queryParams, setQueryParams] = useState<SpedDocumentListRequest>({
    ...convertParams<SpedDocumentListRequest>({
      status: 'string',
      companyId: 'number',
    }),
  });

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  const { setLocation } = usePageSearchHistory();
  useEffect(setLocation, [queryDebounce]);

  const spedDocumentList = useSpedDocumentList(queryDebounce);

  const spedDocuments =
    spedDocumentList.data?.pages.flatMap((page) => page.items) || [];

  return (
    <>
      <div style={{ marginBottom: 24 }}>
        <SpedDocumentListFilter
          onChange={setQueryParams}
          values={queryDebounce}
        />
      </div>

      <InfiniteTable
        dataSource={spedDocuments}
        loading={spedDocumentList.isLoading}
        isFetching={spedDocumentList.isFetching}
        fetchNextPage={spedDocumentList.fetchNextPage}
        hasNextPage={spedDocumentList.hasNextPage}
        columns={[
          { title: 'Empresa', dataIndex: 'companyName' },
          {
            title: 'Período',
            render: (_, item) =>
              moment([
                Number(item.assessmentYear),
                Number(item.assessmentMonth) - 1,
              ]).format('MMMM/YYYY'),
          },
          {
            title: 'Status',
            render: (_, item) =>
              item.status ? (
                <StatusTag
                  label={SpedDocumentStatusLabel[item.status]}
                  color={SpedDocumentStatusColor[item.status]}
                />
              ) : (
                '-'
              ),
          },
          {
            title: 'Ação',
            width: 100,
            align: 'right',
            render: (_, item) => (
              <Group position="right" gap={16}>
                <SpedDocumentEditAction spedDocument={item} />
                <SpedDocumentDeleteAction spedDocument={item} />
              </Group>
            ),
          },
        ]}
      />
    </>
  );
}
